import React from 'react';
import { CheckCircle, Package, Truck } from 'lucide-react';

const Produits = ({ produits, setCurrentPage }) => {
  const getProductImage = (nom) => {
    switch(nom) {
      case 'Acide Chlorhydrique':
        return '/images/acide-chlorhydrique.jpg';
      case 'Soude Caustique 50%':
        return '/images/soude-caustique.jpg';
      case 'Hypochlorite de Sodium':
        return '/images/hypochlorite-sodium.jpg';
      default:
        return null;
    }
  };

  return (
    <div className="produits">
      {/* Header avec vidéo optimisée */}
      <section className="hero" style={{
        position: 'relative',
        overflow: 'hidden',
        minHeight: '650px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0A2E5C 0%, #1e3a8a 50%, #2d5a9e 100%)',
        marginBottom: '60px'
      }}>
        {/* Vidéo optimisée - suppression de l'overlay */}
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          preload="metadata"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
            opacity: 1
          }}
          onError={(e) => {
            if (process.env.NODE_ENV === 'development') {
              console.warn('Erreur de chargement vidéo:', e);
            }
            e.target.style.display = 'none';
          }}
        >
          <source 
            src="/videos/produits-background.mp4" 
            type="video/mp4"
          />
          <source 
            src="/videos/produits-background.webm" 
            type="video/webm"
          />
          Votre navigateur ne supporte pas la vidéo HTML5.
        </video>
        
        <div className="container" style={{ position: 'relative', zIndex: 2, textAlign: 'center', maxWidth: '900px' }}>
          <div style={{
            display: 'inline-block',
            padding: '10px 20px',
            backgroundColor: 'rgba(255, 107, 53, 0.2)',
            borderRadius: '50px',
            marginBottom: '20px',
            border: '1px solid rgba(255, 107, 53, 0.5)'
          }}>
            <span style={{ 
              color: '#FF6B35', 
              fontSize: '14px',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Catalogue Complet
            </span>
          </div>
          <h1 className="hero-title" style={{ 
            color: '#fff', 
            textShadow: '3px 3px 8px rgba(0,0,0,0.4)',
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '20px',
            lineHeight: '1.2'
          }}>
            Nos Produits Chimiques
          </h1>
          <p className="hero-subtitle" style={{ 
            color: '#dbeafe', 
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            fontSize: '18px',
            marginBottom: '30px',
            lineHeight: '1.6'
          }}>
            Gamme complète de produits chimiques essentiels pour l'industrie — Qualité garantie, Certification ISO 9001:2015
          </p>
          <div style={{
            display: 'flex',
            gap: '15px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => setCurrentPage('devis')}
              className="btn-primary"
            >
              Demander un Devis
            </button>
            <button
              onClick={() => setCurrentPage('nitrokym')}
              className="btn-secondary"
            >
              À Propos de Nitrokym
            </button>
          </div>
        </div>
      </section>

      {/* Produits */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: '50px' }}>Nos Produits Principaux</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '40px',
            marginTop: '30px'
          }}>
            {produits.map((produit, idx) => (
              <div
                key={produit.nom}
                style={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  backgroundColor: 'white',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  cursor: 'pointer',
                  transform: 'translateY(0)',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-12px)';
                  e.currentTarget.style.boxShadow = '0 16px 40px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Product Header Image */}
                <div style={{
                  backgroundImage: `url(${getProductImage(produit.nom)})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  height: '240px',
                  position: 'relative',
                  color: 'white',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  padding: '30px 20px',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.35)',
                    zIndex: 1
                  }
                }}>
                  {/* Badge */}
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px',
                    backgroundColor: '#FF6B35',
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    zIndex: 3
                  }}>
                    Produit {idx + 1}
                  </div>
                  
                  <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
                    <div style={{ 
                      fontSize: '13px',
                      fontWeight: '600',
                      marginBottom: '8px',
                      letterSpacing: '1px',
                      textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                      textTransform: 'uppercase'
                    }}>
                      {produit.formule}
                    </div>
                    <h2 style={{ 
                      fontSize: '26px',
                      fontWeight: '700',
                      textShadow: '2px 2px 6px rgba(0,0,0,0.8)',
                      margin: 0,
                      lineHeight: '1.2'
                    }}>
                      {produit.nom}
                    </h2>
                  </div>
                </div>

                {/* Product Body */}
                <div style={{ padding: '30px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                  {/* Specifications */}
                  <div style={{ marginBottom: '25px' }}>
                    <h4 style={{ 
                      color: '#0A2E5C', 
                      marginBottom: '15px', 
                      fontSize: '15px', 
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Spécifications
                    </h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
                        <span style={{ fontWeight: '600', color: '#555' }}>Concentration :</span>
                        <span style={{ color: '#666' }}>{produit.concentration}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                        <span style={{ fontWeight: '600', color: '#555' }}>Emballage :</span>
                        <span style={{ color: '#666' }}>{produit.emballage}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Applications */}
                  <div style={{ marginBottom: '25px' }}>
                    <h4 style={{ 
                      color: '#0A2E5C', 
                      marginBottom: '12px', 
                      fontSize: '15px', 
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Applications
                    </h4>
                    <ul style={{ paddingLeft: '20px', color: '#666', fontSize: '14px', lineHeight: '1.8' }}>
                      {produit.applications.map((app, idx) => (
                        <li key={idx} style={{ marginBottom: '6px' }}>
                          {app}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  {/* Description */}
                  <p style={{ 
                    color: '#666', 
                    lineHeight: '1.7', 
                    marginBottom: '25px', 
                    fontSize: '14px',
                    flex: 1
                  }}>
                    {produit.description}
                  </p>
                  
                  {/* CTA Button */}
                  <button 
                    onClick={() => setCurrentPage('devis')}
                    style={{
                      padding: '14px 24px',
                      backgroundColor: '#0A2E5C',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '15px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      width: '100%',
                      letterSpacing: '0.5px'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#FF6B35'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#0A2E5C'}
                  >
                    Demander un Devis
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #f0f4f8 100%)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <h2 className="section-title">Pourquoi Choisir Nitrokym ?</h2>
            <p style={{ fontSize: '16px', color: '#666', maxWidth: '600px', margin: '20px auto' }}>
              Nous nous engageons à fournir des produits chimiques de qualité supérieure avec un service client exceptionnel
            </p>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '35px'
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '40px 30px',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{ 
                width: '70px', 
                height: '70px', 
                backgroundColor: '#e8f4f8',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <CheckCircle size={40} color="#28a745" />
              </div>
              <h3 style={{ color: '#0A2E5C', marginBottom: '12px', fontSize: '19px', fontWeight: '700' }}>
                Qualité Certifiée
              </h3>
              <p style={{ color: '#666', lineHeight: '1.7', fontSize: '15px' }}>
                Tous nos produits sont conformes aux spécifications techniques 
                avec certification ISO 9001:2015.
              </p>
            </div>

            <div style={{
              backgroundColor: 'white',
              padding: '40px 30px',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{ 
                width: '70px', 
                height: '70px', 
                backgroundColor: '#e3f2fd',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <Package size={40} color="#007BFF" />
              </div>
              <h3 style={{ color: '#0A2E5C', marginBottom: '12px', fontSize: '19px', fontWeight: '700' }}>
                Emballages Sécurisés
              </h3>
              <p style={{ color: '#666', lineHeight: '1.7', fontSize: '15px' }}>
                Emballages adaptés à chaque produit garantissant une manipulation 
                et un transport sécurisés.
              </p>
            </div>

            <div style={{
              backgroundColor: 'white',
              padding: '40px 30px',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{ 
                width: '70px', 
                height: '70px', 
                backgroundColor: '#fff3e0',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <Truck size={40} color="#fd7e14" />
              </div>
              <h3 style={{ color: '#0A2E5C', marginBottom: '12px', fontSize: '19px', fontWeight: '700' }}>
                Livraison Fiable
              </h3>
              <p style={{ color: '#666', lineHeight: '1.7', fontSize: '15px' }}>
                FRTT, filiale du Groupe ECI, est votre partenaire logistique de confiance pour des livraisons garanties dans les délais convenus sur toute la Tunisie.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Fiches Techniques */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
              <h2 className="section-title">Fiches Techniques & Sécurité</h2>
              <p style={{ fontSize: '16px', color: '#666', marginTop: '15px', lineHeight: '1.7' }}>
                Nos fiches techniques et fiches de données de sécurité sont confidentielles. 
                <br />
                Remplissez une demande pour les recevoir rapidement par email.
              </p>
            </div>
            
            {/* Documentation Cards */}
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              {produits.map(produit => (
                <div key={produit.nom} style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '25px',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.borderColor = '#FF6B35';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.05)';
                  e.currentTarget.style.borderColor = '#e9ecef';
                }}>
                  <div style={{ marginBottom: '15px' }}>
                    <h4 style={{ 
                      color: '#0A2E5C', 
                      fontSize: '16px', 
                      fontWeight: '700',
                      margin: '0 0 5px 0'
                    }}>
                      {produit.nom}
                    </h4>
                    <p style={{ 
                      color: '#666', 
                      fontSize: '13px',
                      margin: '5px 0',
                      fontWeight: '500'
                    }}>
                      {produit.formule}
                    </p>
                    <p style={{ 
                      color: '#999', 
                      fontSize: '12px',
                      margin: '5px 0'
                    }}>
                      {produit.concentration}
                    </p>
                  </div>
                  <button 
                    onClick={() => setCurrentPage('devis')}
                    style={{
                      width: '100%',
                      padding: '10px 15px',
                      backgroundColor: '#0A2E5C',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: '600',
                      fontSize: '13px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#FF6B35'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#0A2E5C'}
                    title="Demander les fiches par email"
                  >
                    Demander les fiches
                  </button>
                </div>
              ))}
            </div>

            {/* CTA Section */}
            <div style={{ 
              padding: '40px',
              background: 'linear-gradient(135deg, #e8f4f8 0%, #f0f9ff 100%)',
              borderRadius: '12px',
              border: '1px solid #d1e8f0',
              textAlign: 'center'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '15px',
                marginBottom: '15px'
              }}>
                <span style={{ fontSize: '24px' }}></span>
                <h4 style={{ color: '#0A2E5C', fontSize: '17px', fontWeight: '700', margin: 0 }}>
                  Information Importante
                </h4>
              </div>
              <p style={{ color: '#0A2E5C', marginBottom: '20px', fontSize: '15px', lineHeight: '1.6' }}>
                Tous les fichiers techniques (fiches techniques, fiches de données de sécurité, etc.) sont <strong>confidentiels et réservés aux clients autorisés</strong>. 
                <br />
                Votre demande sera traitée rapidement par notre équipe commerciale dans les 24 heures.
              </p>
              <button 
                onClick={() => setCurrentPage('devis')}
                style={{
                  padding: '16px 40px',
                  backgroundColor: '#0A2E5C',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '700',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 15px rgba(10, 46, 92, 0.2)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#FF6B35';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 107, 53, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0A2E5C';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(10, 46, 92, 0.2)';
                }}
              >
                Demander une Documentation Complète
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Produits;